@let resultValue = result();

@if (resultValue) {
  @if (resultValue.status === 'in_progress') {
    <div class="flex items-center">
      <!-- Left column: emoji -->
      <div class="text-2xl flex-shrink-0 mr-3">⌛</div>
      <!-- Right column: text -->
      <div class="flex flex-col">
        <span class="font-bold">Ping :</span>
        <span>{{ resultValue.latencyMs }} ms</span>
      </div>
    </div>
  }

  @if (resultValue.status === 'sucess') {
    <div class="flex items-center">
      <!-- Left column: emoji -->
      <div class="text-2xl flex-shrink-0 mr-3">✅</div>
      <!-- Right column: text -->
      <div class="flex flex-col">
        <span class="font-bold">Ping :</span>
        <span>{{ resultValue.latencyMs }} ms</span>
      </div>
    </div>
  }
}
